import { memo } from 'react'
import { KEY_LABEL_NO_DATA_SHOW, MODULE_PREVIEW_ROUTER_FORM } from 'config/const/locale'
import { useTranslation } from 'react-i18next'

function NoDataComponent() {

    const { t } = useTranslation(MODULE_PREVIEW_ROUTER_FORM)

    return (
        <div style={{ marginTop: 80, marginBottom: 80, fontSize: 22 }}>
            {t(KEY_LABEL_NO_DATA_SHOW)}
        </div>
    )
}

export default memo(NoDataComponent)
